import { render, staticRenderFns } from "./ModalList.vue?vue&type=template&id=2f82bb58&"
import script from "./ModalList.vue?vue&type=script&lang=js&"
export * from "./ModalList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports